export default "__VITE_ASSET__CLqzObkv__"